/* ============================================================
   ADEQO COLLECTION LANDING — houtenfamilie (col-hw-*)
   Laadt naast collection-gevel.js (kleurwissel in de hero) en alleen op
   een landing met een [hw-]-token. Vijf onderdelen:
   1. Kleurengrid: lengte- en tintfilter, links per lengte, winkelwagen.
   2. Berekening: aantal panelen, staffel van BSS, totaal.
   3. Opbouw: koppelt paneel-opbouw.js aan [data-hw-viz].
   4. Inspiratie: filter per ruimte, "toon meer" en een lightbox.
   Alle tekst komt uit de Liquid (data-attributen), niets staat hier in
   één taal vast.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- 1. Kleurengrid ---------- */

  function initKleuren(root) {
    var cards = root.querySelectorAll('[data-hw-card]');
    if (!cards.length) return;
    var lenBtns = root.querySelectorAll('[data-hw-len-btn]');
    var tintBtns = root.querySelectorAll('[data-hw-tint-btn]');
    var promo = root.querySelector('[data-hw-promo]');
    var empty = root.querySelector('[data-hw-empty]');
    var tint = '';

    function press(btns, on) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b === on ? 'true' : 'false'); });
    }

    function applyTint() {
      var shown = 0;
      cards.forEach(function (c) {
        var on = !tint || c.getAttribute('data-hw-tint') === tint;
        c.hidden = !on;
        if (on) shown++;
      });
      if (promo) promo.hidden = !!tint;
      if (empty) empty.hidden = shown > 0;
    }

    lenBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var len = b.getAttribute('data-hw-len-btn');
        press(lenBtns, b);
        /* Brandvertragend ([bv-kleuren]): het grid kent het formaat (kaarten
           zonder dat formaat verdwijnen via css) en kaarten met dat formaat
           als product staan vooraan. Zonder data-hw-has verandert er niets. */
        var grid = root.querySelector('.hw-cards');
        if (grid && grid.hasAttribute('data-len')) grid.setAttribute('data-len', len);
        cards.forEach(function (c) {
          if (c.hasAttribute('data-hw-has')) {
            c.style.order = (' ' + c.getAttribute('data-hw-has') + ' ').indexOf(' ' + len + ' ') < 0 ? 1 : 0;
          }
          var url = null;
          c.querySelectorAll('[data-hw-len]').forEach(function (el) {
            var on = el.getAttribute('data-hw-len') === len;
            el.hidden = !on;
            if (on) url = el.getAttribute('data-hw-url');
          });
          if (url) c.querySelectorAll('[data-hw-card-link]').forEach(function (a) { a.href = url; });
        });
      });
    });

    tintBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        tint = b.getAttribute('data-hw-tint-btn');
        press(tintBtns, b);
        applyTint();
      });
    });

    root.querySelectorAll('[data-hw-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!window.AdeqoCart || btn.disabled) return;
        var label = btn.textContent;
        btn.disabled = true;
        window.AdeqoCart.add([{ id: Number(btn.getAttribute('data-hw-add')), quantity: 1 }], { source: 'collection-houten' })
          .then(function () {
            btn.textContent = btn.getAttribute('data-hw-added') || label;
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- 2. Berekening ---------- */

  function staffelTiers() {
    /* De B2C-regel: een regel van BSS zonder klanttags. Dezelfde bron als
       de winkelwagen (cart-drawer-adeqo.js). */
    var qb = window.BSS_B2B && window.BSS_B2B.qb;
    var rules = (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
    var rule = rules.filter(function (r) { return !r.customer_tags; })
      .sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); })[0];
    if (!rule || !Array.isArray(rule.qty_table)) return [];
    return rule.qty_table.map(function (t) {
      return { from: t.qty_from, to: t.qty_to == null ? Infinity : t.qty_to, pct: parseFloat(t.discount_value) || 0 };
    });
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'nl';
    try {
      /* Zonder spatie na het teken, zoals de bedragen uit Liquid (€95,00). */
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100).replace(/^([^\d\s-]+)\s/, '$1');
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function num(n, digits) {
    var lang = document.documentElement.lang || 'nl';
    return new Intl.NumberFormat(lang, { maximumFractionDigits: digits }).format(n);
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : ''; });
  }

  /* Kleinste strook die we bovenaan voorstellen; een smallere leest op de
     wand als een vergissing. */
  var MIN_STRIP = 20;

  function tierFor(tiers, q) {
    var hit = { pct: 0, from: 0 };
    tiers.forEach(function (tr) { if (q >= tr.from && q <= tr.to) hit = tr; });
    return hit;
  }

  /* De opbouw van de wand waarbij u het minst van de naden ziet, en
     daarbinnen de goedkoopste. lens: [{cm, price}], oplopend.
     Past de hoogte in het langste paneel, dan één paneel hoog zonder naad
     (bij een lage wand meerdere stukken uit één paneel). Is de wand hoger,
     dan zo weinig mogelijk rijen: per kolom hele panelen, en bovenaan de
     smalste strook (minstens MIN_STRIP) uit reststukken, zoveel als er uit
     één paneel gaan. Bij een gelijke strook beslist het bedrag, met de
     staffel per regel. */
  function planWall(wv, hv, lens, tiers) {
    var cols = Math.ceil(wv / 60);
    var longest = lens[lens.length - 1].cm;
    var best = null;

    function consider(full, strip) {
      var qty = {};
      full.forEach(function (l) { qty[l.cm] = (qty[l.cm] || 0) + cols; });
      qty[strip.from.cm] = (qty[strip.from.cm] || 0) + Math.ceil(cols / strip.per);
      var lines = [], total = 0, count = 0;
      lens.forEach(function (l) {
        var q = qty[l.cm];
        if (!q) return;
        var tr = tierFor(tiers, q);
        var sum = Math.round(l.price * q * (1 - tr.pct / 100));
        lines.push({ len: l, qty: q, pct: tr.pct, from: tr.from, each: Math.round(l.price * (1 - tr.pct / 100)) });
        total += sum; count += q;
      });
      var c = { cols: cols, full: full, strip: strip, lines: lines, total: total, count: count };
      /* Eerst het mooiste: de smalste strook, dus de naad zo hoog mogelijk
         tegen het plafond. Pas daarna het laagste bedrag. */
      if (!best || strip.cm < best.strip.cm ||
          (strip.cm === best.strip.cm && (total < best.total ||
          (total === best.total && (count < best.count || (count === best.count && lines.length < best.lines.length)))))) best = c;
    }

    function tops(full, r) {
      lens.forEach(function (l) { if (l.cm >= r) consider(full, { cm: r, from: l, per: Math.floor(l.cm / r) }); });
    }

    if (hv <= longest) {
      tops([], hv);
      return best;
    }
    var rows = Math.ceil(hv / longest);
    [MIN_STRIP, 1].some(function (min) {
      (function pick(full, start) {
        if (full.length === rows - 1) {
          var r = hv - full.reduce(function (s, l) { return s + l.cm; }, 0);
          if (r >= min && r <= longest) tops(full, r);
          return;
        }
        for (var i = start; i < lens.length; i++) pick(full.concat([lens[i]]), i);
      })([], 0);
      return !!best;
    });
    return best;
  }

  function initCalc(root) {
    var el = root.querySelector('[data-hw-calc]');
    if (!el) return;
    var lengths;
    try { lengths = JSON.parse(el.querySelector('[data-hw-calc-lengths]').textContent); } catch (e) { return; }
    if (!lengths || !lengths.length) return;
    lengths.sort(function (a, b) { return a.cm - b.cm; });

    var w = el.querySelector('[data-hw-calc-w]');
    var h = el.querySelector('[data-hw-calc-h]');
    var t = el.querySelector('[data-hw-i18n]').dataset;
    var out = {
      len: el.querySelector('[data-hw-r-len]'),
      n: el.querySelector('[data-hw-r-n]'),
      tier: el.querySelector('[data-hw-r-tier]'),
      pp: el.querySelector('[data-hw-r-pp]'),
      m2: el.querySelector('[data-hw-r-m2]'),
      tot: el.querySelector('[data-hw-r-tot]')
    };
    var tiers = null;
    var colors = [];
    try { colors = JSON.parse(el.querySelector('[data-hw-calc-colors]').textContent) || []; } catch (e) {}
    var colorIdx = 0;
    var swatches = el.querySelectorAll('[data-hw-calc-color]');
    var addBtn = el.querySelector('[data-hw-calc-add]');
    var extras = el.querySelector('[data-hw-r-extras]');
    var accList = el.querySelector('[data-hw-r-acc]');
    var warn = el.querySelector('[data-hw-r-warn]');
    var accOff = {}; // accessoires die de bezoeker uitvinkte, per variant-id
    var cartItems = [];
    /* Zakelijke klant: geen bedragen, die rekenen met de consumentenprijs.
       De Liquid laat prijs per paneel en totaal dan weg. */
    var b2b = el.hasAttribute('data-hw-b2b');

    function accQty(a, count) {
      if (a.mode === 'per_panels') return a.qty > 0 ? Math.ceil(count / a.qty) : 0;
      return a.qty > 0 ? a.qty : 1;
    }

    function update() {
      if (tiers === null || !tiers.length) tiers = staffelTiers();
      var wv = Math.max(30, parseFloat(w.value) || 0);
      var hv = Math.max(30, parseFloat(h.value) || 0);

      /* Lengtes van de gekozen kleur; een lengte die niet leverbaar is
         doet alleen mee als er anders niets overblijft (dan de melding). */
      var color = colors[colorIdx];
      var all = (color && color.lens.length ? color.lens : lengths).slice()
        .sort(function (a, b) { return a.cm - b.cm; });
      var avail = all.filter(function (l) { return !color || l.ok; });
      var plan = planWall(wv, hv, avail.length ? avail : all, tiers);
      var count = plan.count;
      var total = plan.total;
      var used = plan.lines.map(function (ln) { return ln.len; });
      var main = plan.lines.slice().sort(function (a, b) { return b.qty - a.qty; })[0];

      /* Accessoires van de lengte met de meeste panelen; "per N panelen"
         telt over de hele wand. Aangevinkt tenzij uitgevinkt. */
      cartItems = [];
      var accTotal = 0;
      accList.innerHTML = '';
      var accs = (color && main.len.acc) || [];
      accs.forEach(function (a) {
        var q = accQty(a, count);
        if (!q) return;
        var on = !accOff[a.id];
        var li = document.createElement('li');
        var lab = document.createElement('label');
        var cb = document.createElement('input');
        cb.type = 'checkbox'; cb.checked = on;
        cb.addEventListener('change', function () { if (cb.checked) delete accOff[a.id]; else accOff[a.id] = true; update(); });
        var txt = document.createElement('span');
        var b = document.createElement('b');
        b.textContent = q + ' ' + (q === 1 ? a.u1 : a.u2);
        var sm = document.createElement('small');
        sm.textContent = a.title;
        txt.appendChild(b); txt.appendChild(sm);
        lab.appendChild(cb); lab.appendChild(txt);
        if (!b2b) {
          var pr = document.createElement('span');
          pr.className = 'hw-result__acc-price';
          pr.textContent = money(a.price * q);
          lab.appendChild(pr);
        }
        li.appendChild(lab);
        accList.appendChild(li);
        if (on) { accTotal += a.price * q; cartItems.push({ id: a.id, quantity: q }); }
      });
      extras.hidden = !accList.children.length;

      var ok = !!color && used.every(function (l) { return l.ok; });
      if (color) plan.lines.slice().reverse().forEach(function (ln) { cartItems.unshift({ id: ln.len.id, quantity: ln.qty }); });
      warn.hidden = ok || !color;
      addBtn.disabled = !ok;
      if (!addBtn.classList.contains('is-busy')) addBtn.textContent = count === 1 ? t.addOne : fill(t.add, { count: count });

      /* Omschrijving: kleur, welke panelen, en hoe de wand is opgebouwd */
      var s = plan.strip;
      var desc = [];
      if (color) desc.push(color.name);
      if (plan.lines.length > 1) {
        desc.push(plan.lines.slice().reverse().map(function (ln) { return ln.qty + ' × ' + ln.len.cm + ' cm'; }).join(' ' + t.and + ' '));
      } else {
        desc.push(used[0].cm + ' × 60 cm');
      }
      if (plan.full.length) {
        var parts = plan.full.map(function (l) { return l.cm; }).sort(function (a, b) { return b - a; });
        parts.push(s.cm);
        desc.push(fill(t.column, { parts: parts.join(' + ') + ' cm' }));
      }
      var text = desc.join(', ');
      if (s.per > 1) text += '. ' + fill(plan.full.length ? t.strip : t.split, { cm: s.cm, len: s.from.cm, per: s.per });
      out.len.textContent = text;

      var top = plan.lines.reduce(function (a, b) { return b.pct > a.pct ? b : a; });
      out.n.textContent = fill(t.pieces, { count: count });
      out.m2.textContent = num(wv * hv / 10000, 1) + ' m²';
      if (!b2b) {
        out.tier.textContent = top.pct > 0 ? fill(t.tier, { pct: num(top.pct, 1), from: top.from }) : t.noTier;
        out.pp.textContent = plan.lines.slice().reverse().map(function (ln) { return money(ln.each); }).join(' / ');
        out.tot.textContent = money(total + accTotal);
      }
    }

    function pickColor(b) {
      colorIdx = Number(b.getAttribute('data-hw-calc-color')) || 0;
      swatches.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      update();
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function () { pickColor(b); });
    });

    /* Latvorm: toont alleen de kleuren van die vorm en kiest de eerste */
    var lineBtns = el.querySelectorAll('[data-hw-calc-line]');
    lineBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.getAttribute('data-hw-calc-line');
        lineBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var first = null;
        swatches.forEach(function (x) {
          x.hidden = x.getAttribute('data-line') !== line;
          if (!x.hidden && !first) first = x;
        });
        if (first) pickColor(first);
      });
    });

    addBtn.addEventListener('click', function () {
      if (!window.AdeqoCart || addBtn.disabled || !cartItems.length) return;
      var label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.classList.add('is-busy');
      window.AdeqoCart.add(cartItems, { source: 'collection-houten-berekening' })
        .then(function () {
          addBtn.textContent = addBtn.getAttribute('data-added') || label;
          setTimeout(function () { addBtn.classList.remove('is-busy'); addBtn.disabled = false; update(); }, 2200);
        })
        .catch(function () { addBtn.classList.remove('is-busy'); addBtn.disabled = false; update(); });
    });

    w.addEventListener('input', update);
    h.addEventListener('input', update);
    el.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); });
    update();
    /* BSS laadt soms na ons; dan opnieuw rekenen zodra de regels er zijn. */
    if (!staffelTiers().length) {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (staffelTiers().length || tries > 20) { clearInterval(timer); tiers = null; update(); }
      }, 500);
    }
  }

  /* ---------- 3. Opbouw ---------- */
  /* De tekening zelf staat in paneel-opbouw.js (gedeeld met de
     productpagina); die laadt eerder, dus hier alleen aankoppelen. */

  function initViz(root) {
    if (!window.AdeqoPaneelOpbouw) return;
    root.querySelectorAll('[data-hw-viz]').forEach(window.AdeqoPaneelOpbouw.mount);
  }

  /* ---------- 4. Inspiratie ---------- */

  function initInspiratie(root) {
    var sec = root.querySelector('[data-hw-insp]');
    if (!sec) return;
    var pins = Array.prototype.slice.call(sec.querySelectorAll('[data-hw-pin]'));
    var roomBtns = sec.querySelectorAll('[data-hw-room-btn]');
    var moreBtn = sec.querySelector('[data-hw-more-btn]');
    var room = '';
    var expanded = false;

    function apply() {
      pins.forEach(function (p) {
        var inRoom = !room || p.getAttribute('data-hw-room') === room;
        var extra = p.hasAttribute('data-hw-more');
        p.hidden = !inRoom || (!room && extra && !expanded);
      });
      if (moreBtn) moreBtn.parentNode.hidden = !!room;
    }

    roomBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        room = b.getAttribute('data-hw-room-btn');
        roomBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });

    if (moreBtn) {
      var moreLabel = moreBtn.textContent;
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        moreBtn.textContent = expanded ? moreBtn.getAttribute('data-less') : moreLabel;
        apply();
      });
    }

    var lb = sec.querySelector('[data-hw-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var lbImg = lb.querySelector('[data-hw-lb-img]');
    var lbCap = lb.querySelector('[data-hw-lb-cap]');
    var lbLink = lb.querySelector('[data-hw-lb-link]');
    var current = -1;

    function visiblePins() { return pins.filter(function (p) { return !p.hidden; }); }

    function show(pin) {
      var btn = pin.querySelector('.hw-pin__open');
      var img = btn.querySelector('img');
      lbImg.src = btn.getAttribute('data-hw-full');
      lbImg.alt = img ? img.alt : '';
      var href = btn.getAttribute('data-hw-link');
      lbLink.hidden = !href;
      if (href) lbLink.href = href;
      lbCap.textContent = [btn.getAttribute('data-hw-cap'), btn.getAttribute('data-hw-link-label')].filter(Boolean).join(', ');
      current = visiblePins().indexOf(pin);
    }

    function step(d) {
      var list = visiblePins();
      if (!list.length) return;
      show(list[(current + d + list.length) % list.length]);
    }

    pins.forEach(function (p) {
      p.querySelector('.hw-pin__open').addEventListener('click', function () {
        show(p);
        lb.showModal();
      });
    });
    lb.querySelector('[data-hw-lb-close]').addEventListener('click', function () { lb.close(); });
    lb.querySelector('[data-hw-lb-prev]').addEventListener('click', function () { step(-1); });
    lb.querySelector('[data-hw-lb-next]').addEventListener('click', function () { step(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function init() {
    var root = document.querySelector('.col-landing') || document;
    initKleuren(root);
    initCalc(root);
    initViz(root);
    initInspiratie(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
